import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class AlbumDetailTask extends AbstractRequestTask {
  constructor(params, headers) {
    super();
    this._config = getAppConfig();
    this._headers = headers;
    this._params = {
      ...params,
    };
  }

  getMethod() {
    return "GET";
  }

  getEncType() {
    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    return `${this._config.end_point_music}/middleware/cms/album/${this._params.album_id}/`;
  }

  getParams() {
    const params = super.getParams();
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = "2.0.0";
    return { ...params, ...this._params };
  }

  getHeaders() {
    const headers = {
      ...this._headers
    };
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default AlbumDetailTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/AlbumDetailTask.js